module.exports = __webpack_public_path__ + "img/paddy-power-logo.fb786037.svg";